/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Home_Usecases_Solution_LabelInputs */

const es_home_usecases_solution_label = /** @type {(inputs: Home_Usecases_Solution_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Con Nexata`)
};

const en_home_usecases_solution_label = /** @type {(inputs: Home_Usecases_Solution_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`With Nexata`)
};

/**
* | output |
* | --- |
* | "With Nexata" |
*
* @param {Home_Usecases_Solution_LabelInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const home_usecases_solution_label = /** @type {((inputs?: Home_Usecases_Solution_LabelInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Home_Usecases_Solution_LabelInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_home_usecases_solution_label(inputs)
	return en_home_usecases_solution_label(inputs)
});
export { home_usecases_solution_label as "home.usecases.solution_label" }